<template>
    <div>

        <b-form @submit.prevent="saveSubCategory()" data-vv-scope="formSubCategory">
            <b-row>


                <b-col md="12">
                    <b-form-group>
                        <label>Clase de peligro <span class="text-danger">*</span></label>
                        <el-select v-model="subCategory.sga_category_id" clearable filterable size="medium"
                            placeholder="Seleccionar categoría" name="sga_category_id" v-validate="'required'"
                            data-vv-as=" ">
                            <el-option v-for="item in activeCategories" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formSubCategory.sga_category_id')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Categoría <span class="text-danger">*</span></label>
                        <el-select v-model="subCategory.sga_sub_category_type_id" clearable filterable size="medium"
                            placeholder="Seleccionar categoría" name="sga_sub_category_type_id"
                            v-validate="'required'" data-vv-as=" ">
                            <el-option v-for="item in activeTypesSubCategories" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formSubCategory.sga_sub_category_type_id')" />
                    </b-form-group>
                </b-col>

                <!-- Categoría anterior (solo visible cuando no es la versión principal) -->
                <b-col md="12" v-if="showOldCategorySelect">
                    <b-form-group>
                        <label>Categoría anterior</label>
                        <el-select v-model="subCategory.old_category_id" clearable filterable size="medium"
                            placeholder="Seleccionar categoría anterior" name="old_category_id">
                            <el-option v-for="item in oldCategories" :key="item.id" :label="item.categoria"
                                :value="item.id" />
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col md="12" >
                    <b-form-group>
                        <label>Subcategoría Edición {{ nameVersion }}</label>
                        <el-select v-model="subCategory.main_sga_sub_category_id" clearable filterable size="medium"
                            placeholder="Seleccionar subcategoría" name="main_sga_sub_category_id">
                            <el-option v-for="item in subcategoriesActivesByVersion" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Palabra de advertencia</label>
                        <el-select v-model="subCategory.word_of_caution_id" clearable filterable size="medium"
                            placeholder="Seleccionar palabra de advertencia" name="word_of_cautions_id" v-validate="''"
                            data-vv-as=" ">
                            <el-option v-for="item in activeWordsOfCaution" :key="item.id" :label="item.name"
                                :value="item.id" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formSubCategory.word_of_caution_id')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Indicaciones de peligro</label>
                        <el-select v-model="subCategory.danger_indication_codes_ids" clearable filterable multiple
                            size="medium" placeholder="Seleccionar indicación de peligro"
                            name="danger_indication_codes_ids" v-validate="''" data-vv-as=" ">
                            <el-option v-for="item in activeIndicationsOfDangerSga" :key="item.id"
                                :label="item.code + ' - ' + item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small"
                            v-text="errors.first('formSubCategory.danger_indication_codes_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Excepción de países</label>
                        <el-select v-model="subCategory.except_countries_ids" clearable filterable multiple
                            size="medium" placeholder="Seleccionar pais de excepción" name="except_countries_ids"
                            v-validate="''" data-vv-as=" ">
                            <el-option v-for="item in countriesWithConfig" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formSubCategory.except_countries_ids')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label>Pictogramas</label>
                        <b-row class="flex-wrap ml-1">
                            <b-col class="d-flex justify-content-center" v-for="(pictogram, index) in activePictograms"
                                :key="index" cols="3" md="2" lg="2">
                                <b-img @click="selectedPictogram(pictogram)" :class="pictogramsClass(pictogram)"
                                    thumbnail fluid :src="pictogram.image" :alt="pictogram.name"
                                    style="max-width: 75px; max-height: 75px; margin: 0.5rem;"></b-img>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>

                <b-col md="12" v-if="hasValidLanguages">
                    <b-list-group>
                        <b-list-group-item v-for="(value, code) in subCategory.combined_names" :key="code"
                            v-if="code !== 'ES'">
                            <div class="d-flex align-items-center">
                                <div class="flex-grow-1">
                                    <span class="fw-bold form-control form-control-sm w-100">
                                        {{ subCategory.combined_names[code] }}
                                    </span>
                                </div>
                                <div class="ms-auto ml-2">
                                    <b-badge variant="primary">{{ code }}</b-badge>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelSubCategory">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'FormSubCategories',

    computed: {
        ...mapState('sgaSubCategories', ['action', 'subCategory', 'subcategoriesActivesByVersion']),
        ...mapState('sgaCategories', ['activeCategories', 'oldCategories']),
        ...mapState('sgaWordsOfCaution', ['activeWordsOfCaution']),
        ...mapState('sgaTypesSubCategories', ['activeTypesSubCategories']),
        ...mapState('sgaPictograms', ['activePictograms']),
        ...mapState('sgaIndicationsOfDanger', ['activeIndicationsOfDangerSga']),
        ...mapState('countries', ['countriesWithConfig']),
        ...mapState('sgaVersions', ['activeGlobalVersion', 'mainVersionId', 'version']),

        hasValidLanguages() {
            return this.subCategory && this.subCategory.combined_names && Object.keys(this.subCategory.combined_names).length > 0;
        },

        showOldCategorySelect() {
            // Mostrar cuando las versiones son IGUALES (versión principal)
            return Number(this.mainVersionId) == Number(this.activeGlobalVersion);
        },

        pictogramsClasses() {
            return this.subCategory.sga_sub_category_pictograms.reduce((classes, pictogram) => {
                classes[pictogram.sga_pictogram_id] = 'm-2 p-1 rounded border selected bg-success';
                return classes;
            }, {});
        },

        nameVersion() {
            return this.version.version + ' - ' + this.version.country_names;
        },
    },

    watch: {
        // Asignar la palabra de advertencia que tiene la subcategoría
        "subCategory.sga_sub_category_word_of_caution": {
            handler(value) {
                if (value && value.sga_word_of_caution_id !== null) {
                    this.subCategory.word_of_caution_id = value.sga_word_of_caution_id;
                }
            },
            deep: true
        },

        // Asignar las indicaciones de peligro que tiene la subcategoría
        "subCategory.sga_sub_category_danger_indication_codes": {
            handler(value) {
                if (Array.isArray(value) && value.length > 0) {
                    this.subCategory.danger_indication_codes_ids = value.map(item => item.sga_danger_indication_code_id);
                }
            },
            deep: true
        },

        showOldCategorySelect(newValue) {
            // Si el select de categoría anterior se oculta, limpiar el campo
            if (!newValue && this.subCategory.old_category_id) {
                this.subCategory.old_category_id = null;
            }
        }
    },

    async created() {
        await this.getActiveCategoriesSga({edition_id: this.activeGlobalVersion });
        await this.getActiveWordsOfCautionSga();
        await this.getActiveTypesSubCategoriesSga();
        await this.getActivePictogramsSga();
        await this.loadPictograms();
        await this.getActiveIndicationsOfDangerSga();
        await this.getCountriesWithConfig();
        await this.getOldCategoriesSga();
        await this.getSubCategoriesActivesByVersion(this.version.id);
    },
    methods: {
        ...mapActions('sgaSubCategories', ['createSubCategorySga', 'getSubCategoriesSga', 'updateSubCategorySga', 'getSubCategoriesActivesByVersion']),
        ...mapActions('sgaCategories', ['getActiveCategoriesSga', 'getOldCategoriesSga']),
        ...mapActions('sgaWordsOfCaution', ['getActiveWordsOfCautionSga']),
        ...mapMutations('sgaSubCategories', ['setdefaultSubCategorySga']),
        ...mapActions('sgaTypesSubCategories', ['getActiveTypesSubCategoriesSga']),
        ...mapActions('sgaPictograms', ['getActivePictogramsSga']),
        ...mapActions('sgaIndicationsOfDanger', ['getActiveIndicationsOfDangerSga']),
        ...mapActions('countries', ['getCountriesWithConfig']),

        cancelSubCategory() {
            this.setdefaultSubCategorySga();
            this.$bvModal.hide('modal_create_subcategories');
        },

        async cancelAndGetSubCategories() {
            this.cancelSubCategory();
            await this.getSubCategoriesSga();
        },

        async saveSubCategory() {
            const isValid = await this.$validator.validateAll('formSubCategory');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateSubCategorySga(this.subCategory);
            } else {
                flag = await this.createSubCategorySga(this.subCategory);
            }

            if (flag) {
                this.cancelAndGetSubCategories();
            }
        },

        async loadPictograms() {
            this.subCategory.pictograms_ids = this.subCategory.sga_sub_category_pictograms.map(pictogram => pictogram.sga_pictogram_id);
            this.subCategory.except_countries_ids = this.subCategory.except_countries_ids.map(country => country.id);
        },

        // Seleccionar pictograma para la subcategoría y agregarlo a la lista de pictogramas
        selectedPictogram(pictogram) {
            const index = this.subCategory.pictograms_ids.indexOf(pictogram.id);
            if (index === -1) {
                this.subCategory.sga_sub_category_pictograms.push({ sga_pictogram_id: pictogram.id });
                this.subCategory.pictograms_ids.push(pictogram.id);
            } else {
                this.subCategory.sga_sub_category_pictograms.splice(index, 1);
                this.subCategory.pictograms_ids.splice(index, 1);
            }
        },

        pictogramsClass(pictogram) {
            return this.pictogramsClasses[pictogram.id] || 'm-2 p-1 rounded border pictogram';
        }
    }
}
</script>

<style scoped>
.pictogram {
    background: #eaeaea;
    opacity: 0.2;
    cursor: pointer;
}

.selected {
    opacity: 1;
    cursor: pointer;
    background: #e3ffd9;
}
</style>
